export const FORMAT_DATE_TIME = {
  Time: 'HH:mm',
  TwelveHourTime: 'h:mm A',
  Date: 'DD/MM/YYYY',
  YearFirstDateFormat: 'YYYY-MM-DD',
  DateHyphenFormat: 'DD-MM-YYYY',
  Month: 'MM/YYYY',
  DateTimeHourMinute: 'DD/MM/YYYY HH:mm',
  PatientDOBConsultation: 'DD MMMM, YYYY',
  DiagnosisTime: 'HH:mm DD-MM-YYYY',
  DocumentsTree: 'HH:mm | DD-MM-YYYY',
};

export const TIME_ENUM = {
  DayInWeeksNo: 7,
  TimeMinSelectZone: 5,
  TimeInHours: 60,
  TimeUnixMillisecond: 1000,

  defaultTimeWorkingStartTime: 8,
  defaultTimeWorkingEndTime: 20,
  timeToCompare: 24,
  maxMinutesLimit: 59,
  maxSecondsLimit: 59,
  defaultMinMinutesSecond: 0,
  hourExclude: 1,
  smallestTimeCalendar: 3,
};
export const COUNT_DOWN_TIME = 15; //in second
export const COUNT_DOWN_STEP = 1; //in second
